// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__agk9d","contactsContainer":"Contacts_contactsContainer__1jgIj"};